import { render } from "./NonEditableLayoutEditor.vue?vue&type=template&id=677709ce&scoped=true&ts=true"
import script from "./NonEditableLayoutEditor.vue?vue&type=script&lang=ts"
export * from "./NonEditableLayoutEditor.vue?vue&type=script&lang=ts"

import "./NonEditableLayoutEditor.vue?vue&type=style&index=0&id=677709ce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677709ce"]])

export default __exports__